var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.spinnerClasses,attrs:{"role":"status"}},[(_vm.label)?_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }